











import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import VimeoPlayer from '@vimeo/player';

@Component
export default class ProductVimeoVideo extends Vue {
    @Prop({ type: String, required: true })
    url!: string;

    @Prop({
        required: true,
        type: String
    }) mode!: string;

    @Prop({
        required: true,
        type: Boolean
    }) startVideo!: boolean;

    $refs!: {
        videoMount?: HTMLElement,
        videoPlayMount?: HTMLElement,
    }

    mounted() {
        // Setup the fullscreen video mount
        this.$nextTick(() => {
            if (this.fullscreenMode) {
                if (this.$refs.videoPlayMount) {
                    const playOptions = {
                        url: this.url,
                        controls: true,
                        autoplay: this.startVideo
                    };

                    // eslint-disable-next-line no-new
                    new VimeoPlayer(this.$refs.videoPlayMount, playOptions);
                }
            } else {
                if (this.$refs.videoMount) {
                    const posterOptions = {
                        url: this.url,
                        controls: false,
                        background: false,
                        width: 165
                    };

                    // eslint-disable-next-line no-new
                    new VimeoPlayer(this.$refs.videoMount, posterOptions);
                }
            }
        });
    }

    get fullscreenMode(): boolean {
        return this.mode === 'fullscreen';
    }
}
